<template>
  <a-form-model
    class="formStyle"
    ref="ruleForm"
    :model="ruleForm"
    :rules="rules"
    v-bind="layout"
  >
    <a-form-model-item label="姓名">
      <p></p>
    </a-form-model-item>
    <a-form-model-item label="渠道" prop="pass">
      <a-input v-model="ruleForm.pass" type="password" autocomplete="off" />
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="submitForm('ruleForm')">
        提交
      </a-button>
      <a-button style="margin-left: 10px" @click="resetForm('ruleForm')">
        重置
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        pass: "",
        checkPass: "",
        age: ""
      },
      rules: {
        pass: [
          {
            required: true,
            message: "请选择结算类型",
            trigger: "change"
          }
        ]
      },
      layout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
.formStyle {
  margin: 50px 0;
}
</style>
